export default {
  methods: {
    asyncScript(src) {
      return new Promise((resolve, reject) => {
        var script = document.createElement('script');
        var s = document.getElementsByTagName('script')[0];
        script.onload = resolve;
        script.onerror = reject;
        script.type = 'text/javascript';
        script.async = true;
        script.src = src;
        s.parentNode.insertBefore(script, s);
      });
    }
  }
};